import I18n from 'I18n';
import { createSelector } from 'reselect';
import { Map as ImmutableMap, List, fromJS } from 'immutable';
import { DND_AREA_ID } from 'ContentEditorUI/utils/email/contentTreeUtils';
// @ts-expect-error untyped

import { getFlexAreaTreeAsMap, getFlexAreaIndex } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getLegacyBuiltinModules, getModulesOutsideFlexArea } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
// @ts-expect-error untyped
import { getCanDisplayContentTreeSidebar } from 'EmailEditorUI/redux/selectors/sidebarSelectors';
import { getTemplateContainsFlexArea } from 'EmailEditorUI/redux/selectors/templateInfoSelectors';
// @ts-expect-error untyped
import { getSections } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { BUILTIN_FOOTER, BUILTIN_WEBVERSION } from 'EmailEditorUI/constants/SidebarConstants';
export const getSectionIndexFromLayoutTree = rowName => createSelector(getFlexAreaTreeAsMap, tree => {
  const rootCell = tree.get(DND_AREA_ID).getRootCell();
  return rootCell.getRows().findIndex(row => {
    return row.getName() === rowName;
  });
});
export const getRowNameFromLayoutTreeBySectionIndex = index => createSelector(getFlexAreaTreeAsMap, tree => {
  const rootCell = tree.get(DND_AREA_ID).getRootCell();
  return rootCell.getRows() && rootCell.getRows()[index] && rootCell.getRows()[index].getName();
});
export const getModuleGroupsForEmail = createSelector([getCanDisplayContentTreeSidebar, getTemplateContainsFlexArea, getModulesOutsideFlexArea, getFlexAreaTreeAsMap, getFlexAreaIndex, getLegacyBuiltinModules], (canDisplayContentTreeSidebar, templateContainsFlexArea, modulesOutsideFlexArea, flexAreaTree, flexAreaIndex, builtInModules) => {
  const moduleGroups = {};

  // Built-in modules
  const builtInModulesJs = builtInModules === null || builtInModules === void 0 ? void 0 : builtInModules.toJS();
  const builtInModulesKeys = [BUILTIN_WEBVERSION, BUILTIN_FOOTER];
  builtInModulesKeys.forEach(key => {
    const module = builtInModulesJs[key];
    if (module !== null && module !== void 0 && module.rendered) {
      const {
        type,
        order,
        label
      } = module;
      moduleGroups[key] = {
        index: order,
        type,
        label,
        modules: List([fromJS(Object.assign({}, module, {
          type
        }))])
      };
    }
  });

  // Static modules
  modulesOutsideFlexArea.forEach(module => {
    const type = module.type;
    const label = module.label || I18n.text('layoutBuilderSidebar.elements.label.notFound');
    moduleGroups[module.id] = {
      index: module.order,
      type,
      label,
      modules: List([fromJS(Object.assign({}, module, {
        type
      }))])
    };
  });
  if (canDisplayContentTreeSidebar && templateContainsFlexArea) {
    moduleGroups[DND_AREA_ID] = {
      index: flexAreaIndex,
      name: DND_AREA_ID,
      type: 'layout_section',
      label: I18n.text('layoutBuilderSidebar.sidebar.tree.flexArea'),
      modules: flexAreaTree.get(DND_AREA_ID).getRootCell()
    };
  }
  return ImmutableMap(moduleGroups).sortBy(value => value.index);
});
export const getSectionFromTreeIndex = createSelector([getSections, (state, index) => index], (sections, index) => {
  return sections.get(index);
});